export default "__VITE_ASSET__BkBfpTe5__"